function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function getWait(wait) {
    return typeof wait === "function" ? wait() : wait;
}
function defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}
function debounce(fn, wait, options) {
    if (wait === void 0) wait = 0;
    if (options === void 0) options = {};
    var flush = function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    };
    var lastCallAt;
    var deferred;
    var timer;
    var pendingArgs = [];
    return function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var currentWait = getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        if (isCold && options.leading) {
            var _fn;
            return options.accumulate ? Promise.resolve(fn.call(this, [
                args
            ])).then(function(result) {
                return result[0];
            }) : Promise.resolve((_fn = fn).call.apply(_fn, [
                this
            ].concat(_to_consumable_array(args))));
        }
        if (deferred) {
            clearTimeout(timer);
        } else {
            deferred = defer();
        }
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
}
var debounceDynamic = function(func, wait) {
    if (wait === void 0) wait = function() {
        return 0;
    };
    // USE DEBOUNCE INSTEAD
    var timeout;
    var waitPrev = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timeout);
        waitPrev = wait(waitPrev);
        timeout = setTimeout(function() {
            timeout = null;
            waitPrev = null;
            func.apply(void 0, _to_consumable_array(args));
        }, waitPrev);
    };
};
export default debounce;
export { debounceDynamic };

//# sourceMappingURL=debounce.js.map